export default "__VITE_PUBLIC_ASSET__129ecb33__"